<template>
  <v-toolbar
    height="50"
    dark
    prominent
    image="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
  >
    <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
    <v-toolbar-title></v-toolbar-title>

    <v-spacer></v-spacer>
    <v-btn id="menu-activator" icon>
      <v-icon>person</v-icon>
    </v-btn>

    <v-menu activator="#menu-activator">
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :value="index"
          @click="item.func()"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="loginOrOut()">{{
          this.username().value !== undefined
            ? "(" + this.username().value + ")" + " abmelden"
            : "anmelden"
        }}</v-list-item>
      </v-list>
    </v-menu>
    <SettingsDialog
      :showDialogValChanged="showDialogValChanged"
      :showDialogVal="dialog"
      width="auto"
    >
    </SettingsDialog>
    <!-- 
      <v-btn icon>
        <v-icon>person</v-icon>
      </v-btn> -->
  </v-toolbar>
</template>
 
<script>
import { storeToRefs } from "pinia";
import Vue from "vue";
import KeycloakService from "../services/keycloak-service";
import { useAuthStore } from "../store/auth-store";
import { useUserprofileStore } from "../store/userprofile-store";
import SettingsDialog from "./SettingsDialog.vue";

export default Vue.extend({
  name: "TopBar",
  components: {
    SettingsDialog,
  },

  props: {},

  data: () => ({
    keycloak: undefined,
    data: undefined,
    dialog: false,
    items: [],
  }),
  watch: {},
  mounted() {

    this.items = [
      { title: "Einstellungen", func: () => (this.dialog = true) },
      // { title: this.username().value !== undefined ? '(' + this.username().value + ')' + " abmelden" : "anmelden", func: () => this.username().value !== undefined ? KeycloakService.logoutKeycloak() : KeycloakService.loginKeycloak() },
    ];
  },
  computed: {},

  async created() {},
  watch: {},
  methods: {
    loginOrOut() {
      this.username().value !== undefined
        ? KeycloakService.logoutKeycloak()
        : KeycloakService.loginKeycloak();
    },
    username() {
      return storeToRefs(useAuthStore()).username;
    },
    getUser() {
      
      let useAuth = useAuthStore();
      
      let useUserprofile = useUserprofileStore();
      useUserprofile.fetchTransportSettings("7")
      const userRef = storeToRefs(useAuth).username;
      // console.log("UserRef-username=", userRef);
      // console.log("authenticated=", KeycloakService.keycloakObj); // this.data, this.keycloak);
      // let keycloak =  keycloakService?.keycloakObj;
      //  this.authenticated = keycloak.authenticated;
      // this.user.username = keycloak.idTokenParsed.preferred_username;
      // this.user.token = keycloak.token;
      // this.user.refToken = keycloak.refreshToken;
      // keycloakService.keycloakObj.loadUserProfile().then(p => console.log("userprofile=",p)).catch(err => console.log("userprofile error: ", err))
    },
    showSettingsDialog() {
      this.dialog = true;
    },
    showDialogValChanged(val) {
      this.dialog = val;
    },
   
  },
});
</script>
<style scoped>
</style>
   
 